var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"woo-tutorial-help-drawer",attrs:{"fixed":"","bottom":"","right":"","touchless":"","mobile-breakpoint":"960","temporary":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('helper-playlist',{attrs:{"onCloseHelp":_vm.toggleHelpDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }